import React from "react";

function Footer() {
  return (
    <footer className="footer fixed-bottom mt-auto py-2 bg-dark-gray border-top border-yellow-green border-3">
      <h6 className="d-flex my-auto justify-content-center text-yellow-green">
        Made with ❤ by Bickolus
      </h6>
    </footer>
  );
}

export default Footer;
